import React from "react";
import { useTheme } from "@/context/ThemeContext";

/** sanskariBazarIn brand mark — the supplied logo image used everywhere we
 * previously rendered the text wordmark.
 *
 * The source image swaps automatically based on the active theme so the
 * logo always sits on a plate that matches the background:
 *   - `darknight`  → black-plate variant (`/brand/sanskari-dark.png`)
 *   - `evening`    → blue-plate variant  (`/brand/sanskari-evening.png`)
 *   - everything else (sunny, default)  → original `/logo.png`
 *
 * Props
 *   size       — pixel height of the image (width auto). Default 36.
 *   width      — explicit pixel width (overrides auto). Optional.
 *   height     — explicit pixel height (overrides `size`). Optional.
 *   className  — extra classes for the wrapper.
 */
const THEME_LOGOS = {
  darknight: "/brand/sanskari-dark.png",
  evening: "/brand/sanskari-evening.png",
};

export default function BrandMark({
  size = 36,
  width,
  height,
  className = "",
  alt = "sanskariBazarIn",
}) {
  const themeCtx = useTheme();
  const themeId = themeCtx?.theme;
  const src = THEME_LOGOS[themeId] || "/logo.png";

  const style = {
    height: height ?? size,
    width: width ?? "auto",
    objectFit: "contain",
  };
  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={`block select-none drop-shadow-sm ${className}`}
      draggable={false}
      data-testid="brand-mark"
      data-theme-variant={themeId || "default"}
    />
  );
}
